import api from './api'

export function fetchCharacterSheets(userId) {
  return api.get('/character-sheets', {
    params: { userId }
  })
}

export function createCharacterSheet(payload) {
  return api.post('/character-sheets', payload)
}

export function updateCharacterSheet(id, payload) {
  return api.put(`/character-sheets/${id}`, payload)
}

export function deleteCharacterSheet(id, userId) {
  return api.delete(`/character-sheets/${id}`, {
    data: { userId }
  })
}
